import { FieldEditorProps } from './FieldEditorProps';
import '../styles/Editors.scoped.scss';
import questionTypes from 'FlowBuilder/components/ActionForms/Survey/question-types'
import { QuestionForm } from 'FlowBuilder/components/ActionForms/Survey/SurveyPageForm'
import { useAct } from 'DashboardBuilder/store'

export const AnswerableQuestionEditor = ({ field, onChange }: FieldEditorProps) => {
  const act = useAct()
  const { questionId } = field
  const question = useSel(s => s.questions.entities[questionId] || {})
  const questionConfig = questionTypes[question?.questionType]
  const mergeTags = {}

  function chooseQuestionType(questionType) {
    act.dashboardFields.chooseQuestionType(field.id, questionType)
  }

  return <>
    <div className="field-editor-row">
      <label>Question Type</label>
      <div className="field-editor-input">
        <select value={question.questionType || ''} onChange={e => chooseQuestionType(e.target.value)}>
          <option value={''}>Choose a question type</option>
          { _.map(questionTypes, (qt, value) => <option value={value}>{qt.name}</option> ) }
        </select>
      </div>
    </div>
    { (questionId && questionConfig) && <div className="field-editor-row">
      <QuestionForm question={question} questionConfig={{...questionConfig, showRequired: false}} mergeTags={mergeTags} />
    </div> }
  </>
}
